const Flag = ({
  stroke_color = "#053242",
  accent_color = "#47D2B1",
  base_color = "#FFFEFC",
  className = "",
}) => (
  <svg
    className={`shrink-0 ${className}`}
    width="54"
    height="84"
    viewBox="0 0 54 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M26.0527 50.9789C33.1398 50.9789 39.4784 51.0267 44.0928 52.184C46.3934 52.761 48.2136 53.6021 49.4766 54.808C50.7251 56.0001 51.465 57.5821 51.5518 59.7269C51.5517 59.725 51.5514 59.7496 51.5518 59.8168C51.5521 59.8773 51.5524 59.9627 51.5527 60.0687C51.5534 60.2806 51.5541 60.5757 51.5547 60.9261C51.5558 61.6274 51.5568 62.5501 51.5576 63.473C51.5592 65.3191 51.5605 67.1654 51.5605 67.2396C51.5605 71.6406 48.7913 75.6933 44.1719 78.6703C39.5576 81.6439 33.1528 83.5003 26.0527 83.5004C18.9524 83.5004 12.547 81.644 7.93262 78.6703C3.31321 75.6933 0.544024 71.6406 0.543945 67.2396C0.543945 66.9461 0.521076 65.2948 0.509766 63.6664C0.504083 62.8482 0.501625 62.0319 0.505859 61.3861C0.507978 61.0632 0.511522 60.7852 0.517578 60.5717C0.520608 60.4648 0.524388 60.3764 0.52832 60.308C0.530277 60.274 0.532293 60.2462 0.53418 60.225C0.53512 60.2144 0.536389 60.2058 0.537109 60.1996C0.53745 60.1966 0.537865 60.1944 0.538086 60.1927C0.538303 60.1911 0.538086 60.1898 0.538086 60.1898C1.16766 56.2429 4.08448 53.9368 8.64746 52.6097C13.2234 51.279 19.324 50.9789 26.0527 50.9789Z"
      fill={base_color}
      stroke={stroke_color}
    />
    <path
      d="M26.0752 43.0916C33.1939 43.0916 39.6157 44.9518 44.2422 47.9333C48.8738 50.9182 51.6503 54.9823 51.6504 59.3953C51.6504 63.8082 48.8738 67.8723 44.2422 70.8572C39.6157 73.8387 33.1939 75.6989 26.0752 75.699C18.9565 75.699 12.5347 73.8387 7.9082 70.8572C3.27646 67.8723 0.5 63.8083 0.5 59.3953C0.500062 54.9823 3.27651 50.9182 7.9082 47.9333C12.5347 44.9519 18.9565 43.0916 26.0752 43.0916Z"
      stroke={stroke_color}
    />
    <path
      d="M26.0732 53.5215C28.7114 53.5215 31.0762 54.2148 32.7666 55.3086C34.462 56.4056 35.4238 57.8617 35.4238 59.3955C35.4238 60.9293 34.4619 62.3854 32.7666 63.4824C31.0762 64.5761 28.7113 65.2695 26.0732 65.2695C23.4352 65.2695 21.0703 64.5761 19.3799 63.4824C17.6846 62.3854 16.7227 60.9293 16.7227 59.3955C16.7227 57.8617 17.6845 56.4056 19.3799 55.3086C21.0703 54.2148 23.4351 53.5215 26.0732 53.5215Z"
      fill={accent_color}
      stroke={stroke_color}
    />
    <path
      d="M26.0322 43.0916C33.138 43.0916 39.548 44.947 44.166 47.9207C48.7894 50.8978 51.5605 54.9514 51.5605 59.3523C51.5605 63.7531 48.7892 67.8059 44.166 70.783C39.548 73.7567 33.1381 75.613 26.0322 75.613C18.9263 75.613 12.5165 73.7567 7.89844 70.783C3.27516 67.8058 0.503982 63.7531 0.503906 59.3523C0.503906 54.9514 3.27509 50.8978 7.89844 47.9207C12.5165 44.947 18.9265 43.0916 26.0322 43.0916Z"
      fill={base_color}
      stroke={stroke_color}
    />
    <path
      d="M26.0312 53.3451C28.6698 53.3451 31.0361 54.052 32.7275 55.1683C34.4227 56.2873 35.3905 57.7768 35.3906 59.3519C35.3906 60.9271 34.4227 62.4166 32.7275 63.5355C31.0361 64.6519 28.6698 65.3587 26.0312 65.3588C23.3927 65.3588 21.0265 64.6519 19.335 63.5355C17.6396 62.4165 16.6719 60.9272 16.6719 59.3519C16.672 57.7767 17.6396 56.2873 19.335 55.1683C21.0265 54.052 23.3927 53.3451 26.0312 53.3451Z"
      fill={accent_color}
      stroke={stroke_color}
    />
    <line x1="25.9219" y1="58.2605" x2="25.9219" y2="23.3732" stroke={stroke_color} strokeLinecap="round" />
    <path
      d="M51.332 13.4697L26.4863 24.7402L25.7803 25.0605L25.7803 0.967772L26.4863 1.28808L51.332 12.5586L52.335 13.0137L51.332 13.4697Z"
      fill={accent_color}
      stroke={stroke_color}
    />
  </svg>
);

export default Flag;
